import React from 'react';
import { connect } from 'react-redux';
import { Form, Select, Button, Row, Col, Tag, message } from 'antd';
import { setIcConfig, setMappingChild, setMappingParent, setMappings, setSelectedHeading, setHeadings } from '../../../redux/actions/IC/ICActions';
import SecondaryFormWrapper from './SecondaryFormWrapper.style';

const FormItem = Form.Item;
const Option = Select.Option;

class AddSecondaryConfig extends React.Component {
  
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChildChange = this.handleChildChange.bind(this);
    this.handleParentChange = this.handleParentChange.bind(this);
    this.handleHeadingOrderChange = this.handleHeadingOrderChange.bind(this);
    this.handleAddMapping = this.handleAddMapping.bind(this);
    this.handleRemoveMapping = this.handleRemoveMapping.bind(this);
    this.handleAddHeadingOrder = this.handleAddHeadingOrder.bind(this);
    this.handleRemoveHeadingOrder = this.handleRemoveHeadingOrder.bind(this);
  }

  handleSubmit = (e) => {
    let that = this;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        
        let form_data = {}, final_heading_order, final_mappings;
        let config_1_keys = Object.keys(that.props.ICREDUCER.selectedValues);
        
        config_1_keys.map(key => form_data[key] = that.props.ICREDUCER.selectedValues[key]);
        
        if(that.props.ICREDUCER.heading_order.headings.length > 0) {
          final_heading_order = that.props.ICREDUCER.heading_order.headings;
        }
        else {
          message.error('Select set of heading orders!');
          return false
        }
        
        if(Object.keys(that.props.ICREDUCER.mappings.cpg_map).length > 0) {
          final_mappings = {
            cpg_map: that.props.ICREDUCER.mappings.cpg_map
          };
        }
        else {
          message.error('Select set of parent-child mappings!');
          return false
        }
        
        form_data['heading_order'] = final_heading_order;
        form_data['mappings'] = final_mappings;
        form_data['calc_exc_fields'] = values.calc_exc_fields || [];
        form_data['drill_downs'] = values.drill_downs;
        form_data['channel_contains'] = values.channel_contains || [];
        form_data['currency'] = values.currency;
        this.props.setIcConfig(form_data, that.props.from);
      }
    });
  }

  handleChildChange(value) {
    this.props.setMappingChild(value);
  }

  handleRemoveMapping(key) {
    const mappings = this.props.ICREDUCER.mappings.cpg_map;
    delete mappings[key];
    this.props.setMappings(mappings);
  }

  handleParentChange(value) {
    this.props.setMappingParent(value);
  }

  handleAddMapping() {
    const mappings = this.props.ICREDUCER.mappings.cpg_map;
    mappings[this.props.ICREDUCER.mappings.child] = this.props.ICREDUCER.mappings.parent;
    this.props.setMappings(mappings);
  }

  handleHeadingOrderChange(value) {
    let new_values;
    if(value.length > 1) {
      new_values = value.join(":");
    }
    else {
      new_values = value[0];
    }
    this.props.setSelectedHeading(new_values);
  }

  handleAddHeadingOrder() {
    let headings = this.props.ICREDUCER.heading_order.headings;
    headings.push(this.props.ICREDUCER.heading_order.selected_heading);
    this.props.setHeadings(headings);
  }

  handleRemoveHeadingOrder(heading) {
    let headings = this.props.ICREDUCER.heading_order.headings;
    let index = headings.indexOf(heading);
    if (index > -1) {
      headings.splice(index, 1);
    }
    this.props.setHeadings(headings);
  }
  
  render() {
    
    const { getFieldDecorator } = this.props.form;

    const filters = this.props.ICREDUCER.selectedValues.hasOwnProperty('filters') ? this.props.ICREDUCER.selectedValues.filters.map((filter,i) => <Option key={i} value={filter}>{filter.split("")[0].toUpperCase()+filter.split("").slice(1).join("")}</Option>) : [] ;
    const type_values = this.props.ICREDUCER.selectedValues.hasOwnProperty('type') ? this.props.ICREDUCER.selectedValues.type.map((type,i) => <Option key={i} value={type.toLowerCase()}>{type}</Option>) : [] ;
    
    let mappings = this.props.ICREDUCER.mappings.cpg_map;
    let mappings_tags = [];
    let mappings_tags_keys = [];
    let heading_order_tags = [];
    let currency_options = [];
    
    if(Object.keys(mappings).length > 0) {
      mappings_tags_keys = Object.keys(mappings);
      mappings_tags = mappings_tags_keys.map(key => <Tag key={key} closable onClose={() => this.handleRemoveMapping(key)}>{key+':'+this.props.ICREDUCER.mappings.cpg_map[key]}</Tag>);
    }

    if(this.props.ICREDUCER.heading_order.headings.length > 0) {
      heading_order_tags = this.props.ICREDUCER.heading_order.headings.map(heading => <Tag key={heading} closable onClose={() => this.handleRemoveHeadingOrder(heading)}>{heading}</Tag>);
    }

    if(this.props.ICREDUCER.selectedValues.base_currency === 'LCU') {
      currency_options = this.props.ICREDUCER.config_1.currencies.map((curr,i) => <Option key={i} value={curr}>{curr}</Option>);
    }
    else {
      currency_options = <Option value={this.props.ICREDUCER.selectedValues.base_currency}>{this.props.ICREDUCER.selectedValues.base_currency}</Option>
    }


    return(
      <SecondaryFormWrapper>
      <Row>
        <Col offset={6} span={12}>
          <Form onSubmit={this.handleSubmit}>
            <Row type="flex" align="middle" gutter={26}>
              <Col span={10}>
                <FormItem
                  label="Select Child"
                >
                  {getFieldDecorator('mapping_childs')(
                    <Select showSearch placeholder="Select child" onChange={this.handleChildChange}>
                      {filters}
                    </Select>
                  )}
                </FormItem>
              </Col>
              <Col span={10}>
                <FormItem
                  label="Select Parent"
                >
                  {getFieldDecorator('mapping_parents')(
                    <Select showSearch placeholder="Select parent" onChange={this.handleParentChange}>
                      {filters}
                    </Select>
                  )}
                </FormItem>
              </Col>
              <Col span={4}>
                <Button type="primary" style={{marginTop: 15}} onClick={this.handleAddMapping}>Add</Button>    
              </Col>
            </Row>
            {mappings_tags}
            
            <FormItem
              label="Calc Exc Fields"
            >
              {getFieldDecorator('calc_exc_fields', {
                initialValue: this.props.ICREDUCER.selectedValues.calc_exc_fields,
                rules: [
                  { required: false, message: 'Please select fields to be set as channels!', type: 'array' },
                ],
              })(
                <Select showSearch mode="multiple" placeholder="Select list of excluded fields(data based on the filters filled up earlier)">
                  {filters}
                </Select>
              )}
            </FormItem>

            <FormItem
              label="Drill Downs"
            >
              {getFieldDecorator('drill_downs', {
                initialValue: this.props.ICREDUCER.selectedValues.drill_downs,
                rules: [
                  { required: true, message: 'Please select the drill down sections!', type: 'array' },
                ],
              })(
                <Select showSearch mode="multiple" placeholder="Select list of drill down sections(data based on the filters filled up earlier)">
                  {filters}
                </Select>
              )}
            </FormItem>

            <FormItem
              label="Heading Order"
            >
              <Row type="flex" align="middle" gutter={26}>
                <Col span={20}>
                  {getFieldDecorator('heading_order', {
                  })(
                    <Select showSearch mode="multiple" onChange={this.handleHeadingOrderChange} placeholder="Select list of drill down sections(data based on the filters filled up earlier)">
                      {filters}
                    </Select>
                    // <Cascader options={options} onChange={this.handleHeadingOrderChange} placeholder="Please select appropriate heading order" />
                  )}
                </Col>
                <Col span={4}>
                  <Button type="primary" onClick={this.handleAddHeadingOrder}>Add</Button>  
                </Col>
              </Row>
            </FormItem>
            {heading_order_tags}

            <FormItem
              label="Channel Contains"
            >
              {getFieldDecorator('channel_contains', {
                initialValue: this.props.ICREDUCER.selectedValues.channel_contains,
                rules: [
                  { required: false, message: 'Please select the correct type values for channels!', type: 'array' },
                ],
              })( 
                <Select showSearch mode="multiple" placeholder="Select the type values for channels!">
                  {type_values}
                </Select>
              )}
            </FormItem>

            <FormItem
              label="Currency"
            >
              {getFieldDecorator('currency', {
                initialValue: this.props.ICREDUCER.selectedValues.currency,
                rules: [
                  { required: true, message: 'Please select your currencies!', type: 'array' },
                  { validator: (rule, value, cb) => ( value.length === 1 && value[0] === 'LCU' ? cb(true) : cb() ), message: 'LCU cannot be the only currency!' }
                ],
              })(
                <Select showSearch mode="multiple" placeholder="Select your currencies">
                  {currency_options}
                </Select>
              )}
            </FormItem>
            

            <FormItem>
              <Button type="primary" htmlType="submit" loading={this.props.ICREDUCER.addingConfigStatus}>Submit</Button>
            </FormItem>

          </Form>
        </Col>
      </Row>
      </SecondaryFormWrapper>
    )
  }
}

function mapStateToProps(state) {
  return state;
}

const mapDispatchToProps = {
  setIcConfig,
  setMappingChild,
  setMappingParent,
  setMappings,
  setHeadings,
  setSelectedHeading
}

const SecondaryForm = Form.create()(AddSecondaryConfig);

export default connect(mapStateToProps, mapDispatchToProps)(SecondaryForm);


// WEBPACK FOOTER //
// ./src/components/IC/SecondaryForm/SecondaryForm.js